import React from 'react';
import styled from '@emotion/styled';
import { Link } from 'gatsby';
import { theme } from '@styles';
import { IPrismicContentApi } from '@appTypes';

const { colors, breakpoints } = theme;

type Props = {
  customTitle?: string;
  customSubtitle?: string;
  subscribeForm?: boolean;
};

const FooterSection: React.FC<Props & IPrismicContentApi> = ({ prismicFooterData }) => {
  const data = prismicFooterData!.edges[0].node.data;
  const { copyright_text, body1: link_sections, footer_logo } = data;

  return (
    <FooterWrapper id='footer'>
      <ContactSection>
        <LogoWrapper>
          <img src={footer_logo.url} alt={footer_logo.alt} />
        </LogoWrapper>
        <LinksWrapper>
          {link_sections.map((section, index) => {
            return (
              <LinksSection key={index}>
                <LinksSectionTitle>{section.primary.title}</LinksSectionTitle>
                {section.items.map((sectionItem, index) => {
                  if (sectionItem.link_is_internal && sectionItem.link_address) {
                    return (
                      <Link to={sectionItem.link_address}>
                        <LinksSectionItem key={index}>{sectionItem.link_label}</LinksSectionItem>
                      </Link>
                    );
                  } else if (!sectionItem.link_is_internal && sectionItem.link_address) {
                    return (
                      <a href={sectionItem.link_address} target='_blank'>
                        <LinksSectionItem>{sectionItem.link_label}</LinksSectionItem>
                      </a>
                    );
                  }
                })}
              </LinksSection>
            );
          })}
        </LinksWrapper>
      </ContactSection>
      <BottomSection>
        <CopyrightText>{copyright_text}</CopyrightText>
      </BottomSection>
    </FooterWrapper>
  );
};

export default FooterSection;

const CopyrightText = styled.div`
  font-size: 12px;
  line-height: 15.6px;
  font-weight: 400;
  @media screen and (min-width: ${breakpoints.desktop}) {
    font-size: 14px;
    line-height: 18.2px;
  }
`;

const LinksWrapper = styled.div`
  display: flex;
  a {
    text-decoration: none;
    &:hover {
      opacity: 0.75;
    }
  }
  flex-wrap: wrap;
  @media screen and (min-width: ${breakpoints.desktop}) {
    gap: 52px;
  }
`;

const LinksSectionItem = styled.div`
  font-size: 14px;
  color: ${colors.grannySmith};
  line-height: 18px;
  font-weight: 400;
`;

const LinksSectionTitle = styled.div`
  color: #fff;
  font-size: 16px;
  line-height: 24px;
  font-weight: 600;
  font-family: 'Poppins';
`;

const LinksSection = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 50%;
  margin-bottom: 52px;
  @media screen and (min-width: ${breakpoints.desktop}) {
    width: initial;
    margin-bottom: initial;
  }
`;

const LogoWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-bottom: 52px;
  @media screen and (min-width: ${breakpoints.desktop}) {
    margin-bottom: initial;
  }
`;

const FooterWrapper = styled.div`
  background: ${colors.outerSpace};
  padding: 38px 24px 50px 24px;
  @media screen and (min-width: ${breakpoints.desktop}) {
    padding: 60px 24px 130px 24px;
    padding-top: 100px;
  }
`;

const BottomSection = styled.div`
  color: #fff;
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 12px auto 0px auto;
  align-items: center;
  @media screen and (min-width: ${breakpoints.desktop}) {
    margin: 0 auto;
  }
`;

const ContactSection = styled.div`
  display: flex;
  justify-content: space-between;
  max-width: 1200px;
  margin: 0 auto;
  flex-direction: column;
  @media screen and (min-width: ${breakpoints.desktop}) {
    flex-direction: row;
  }
`;
